import {
  Button,
  chakra, Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { NumericFormInput } from "../../../components/Forms";
import { nonIntegerSymbols } from "../../../utils";

function ExportModal({ baseYear, isOpen, onClose, onSubmit }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "decarbonization.exportModal"
  });
  const maxExportYear = 2050;

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset
  } = useForm();

  const handleModalClose = () => {
    reset();
    onClose();
  };

  return !isOpen ? null : <Modal isOpen={isOpen} onClose={handleModalClose} size="xl">
    <ModalOverlay />
    <ModalContent>
      <chakra.form onSubmit={handleSubmit((data) => onSubmit(data.exportYear))}>
        <ModalHeader>
          {t("header")}
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody maxHeight={"65vh"} overflow="auto">
          <NumericFormInput
            {...register("exportYear", {
              required: t("errorHandling.emptyYearError"),
              min: {
                value: Number(baseYear),
                message: t("errorHandling.minYearError", { baseYear: baseYear })
              },
              max: {
                value: maxExportYear,
                message: t("errorHandling.maxYearError", { maxYear: maxExportYear })
              }
            })}
            label={t("inputLabel", { baseYear: baseYear, maxYear: maxExportYear })}
            maxInlineSize={{ base: "full", lg: "lg" }}
            errors={errors}
            type="number"
            onKeyDown={(e) => nonIntegerSymbols.includes(e.key) && e.preventDefault()}
            step={1}
          />
        </ModalBody>
        <ModalFooter justifyContent="space-between">
          <Button colorScheme="gray" onClick={handleModalClose}>
            {t("buttons.close")}
          </Button>
          <Flex gap={3}>
            <Button colorScheme="customScheme" type="submit">
              {t("buttons.export")}
            </Button>
          </Flex>
        </ModalFooter>
      </chakra.form>
    </ModalContent>
  </Modal>;
}

export default ExportModal;